import { EditorModes } from 'editor/components/EditorMode';
import Markup from 'editor/components/Markup';
import Overlay from 'editor/components/Overlay';
import SheetEvents from 'editor/components/SheetEvents';
import { ClickArgs } from 'editor/systems/addSheetEvents/sheetEventHandlers';
import {
  BoxControlPoint,
  boxControlPointHit,
  lineControlPointHit,
} from 'editor/utils/controlPoints';
import { getHitMarkups } from 'editor/utils/hitDetection';

const selectMarkupEvents = {
  click({ hit, world, markupKit, mode }: ClickArgs): void {
    const { MKPoint } = markupKit;

    // Everything else in the function only has to do with non-viewonly mode.
    if (mode === EditorModes.ViewOnly) {
      return;
    }

    const hitCps = world
      .locateAll([Markup, Overlay])
      .map((entity) => entity.get(Markup))
      .filter(
        (mc) =>
          mc.selected &&
          (boxControlPointHit(mc, hit) !== BoxControlPoint.None ||
            lineControlPointHit(mc, hit) !== null)
      );

    const hitMarkups = getHitMarkups(world, new MKPoint(hit.x, hit.y)).map(
      (entity) => entity.get(Markup)
    );

    world.grabAll(SheetEvents).forEach(({ component }) => {
      component.emit('sheet:click', { hitMarkups, hitCps });
    });
  },
};

export default selectMarkupEvents;
